/* SEATHERA — apparition au scroll
   Le contenu est masqué au départ (opacity 0) : il est donc impératif que la
   révélation ne puisse jamais échouer. Trois filets de sécurité :
     1. IntersectionObserver avec marge, pour le cas nominal ;
     2. un contrôle au scroll (throttlé en rAF) qui rattrape ce que l'observateur
        aurait manqué — scroll rapide, arrivée sur une ancre, restauration de
        position par le navigateur ;
     3. si l'API manque ou si l'utilisateur refuse les animations, tout est
        révélé immédiatement.
   Sans JavaScript, la classe `js` est absente de <html> et le CSS n'applique
   jamais l'état masqué. */
(function () {
  var SEUIL = 0.88; // hauteur de fenêtre au-delà de laquelle on révèle

  function tousReveler() {
    var els = document.querySelectorAll('.st-rv:not(.on)');
    for (var i = 0; i < els.length; i++) els[i].classList.add('on');
  }

  function revelerCeQuiEstVisible() {
    var els = document.querySelectorAll('.st-rv:not(.on)');
    if (!els.length) return false;
    var limite = window.innerHeight * SEUIL;
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < limite) els[i].classList.add('on');
    }
    return true;
  }

  function init() {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduit || !('IntersectionObserver' in window)) { tousReveler(); return; }

    var observateurAReagi = false;
    var io = new IntersectionObserver(function (entrees) {
      observateurAReagi = true;
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

    /* Garde-fou : si l'observateur n'a rien émis au bout de 3 s, c'est qu'il ne
       fonctionne pas dans ce contexte. Mieux vaut perdre l'animation que laisser
       la page vide. */
    setTimeout(function () { if (!observateurAReagi) tousReveler(); }, 3000);

    document.querySelectorAll('.st-rv:not(.on)').forEach(function (el) { io.observe(el); });

    // Filet de rattrapage
    var enAttente = false;
    function auScroll() {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () {
        enAttente = false;
        if (!revelerCeQuiEstVisible()) {
          window.removeEventListener('scroll', auScroll);
          window.removeEventListener('resize', auScroll);
        }
      });
    }
    window.addEventListener('scroll', auScroll, { passive: true });
    window.addEventListener('resize', auScroll, { passive: true });
    revelerCeQuiEstVisible();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
